<template>
  <div v-bind="$attrs">
    <div class="radio-group" :style="`grid-template-columns: repeat(${customCols}, auto); grid-gap: ${gap}`">
      <div v-for="option in options" >
        <label class="course-radio">
          <input :checked="option.value === value" :name="name" :disabled="option.disabled" type="radio" @change="update(option.value)"/>
          <span></span>
          <div v-html="option.text"></div>
        </label>
      </div>
    </div>

    <small class="text-danger" v-if="error">
      {{ error }}
    </small>
    <span class="help-block" v-if="help">{{ help }}</span>
  </div>
</template>

<style scoped lang="scss">
.radio-group{
  display: grid;
  justify-content: flex-start;
  grid-column-gap: 20px;
  width: 100%;

}
</style>

<script>
export default {
  props: ['value', 'options', 'name', 'error', 'help', 'cols', 'gap', 'disabled', 'mediaQuery'],
  data(){
    return {
      customCols: this.$props?.cols,
    }
  },
  mounted() {
    if (this.$props.mediaQuery?.length) {
      this.mediaQueryListen()
      this.mediaQueryCalculate()
    }
  },

  unmounted() {
    if (this.$props.mediaQuery?.length) {
      this.mediaQueryRemoveListen()
    }
  },
  methods: {
    mediaQueryListen() {
      window.addEventListener('resize', this.mediaQueryCalculate);
    },
    mediaQueryRemoveListen() {
      window.removeEventListener('resize', this.mediaQueryCalculate);
    },
    mediaQueryCalculate() {
      const mediaArray = this.$props.mediaQuery.sort((a, b) => a.media - b.media)
      const self = this;
      mediaArray.forEach((screen, index) => {
        if (window.innerWidth > screen.media) {
          self.customCols = screen.cols
        }
      });
    },
    update(value) {
      this.$emit('input', value)
    }
  }
}
</script>